import { Modal } from 'antd';
import { LuLogOut } from "react-icons/lu";
const LogoutModal = ({ confrimModal, setConfrimModal, onLogout }) => {
  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-600 dark:text-red-400  text-lg font-semibold">
          <LuLogOut size={20} />
          Confirm Logout
        </div>
      }
      centered
      open={confrimModal}
      onOk={onLogout}
      onCancel={() => setConfrimModal(false)}
      okText="Logout"
      cancelText="Cancel"
      okButtonProps={{ className: 'bg-red-500 hover:bg-red-600 text-white' }}
       className="
        dark:[&_.ant-modal-content]:bg-gray-900
        dark:[&_.ant-modal-header]:bg-gray-900
        dark:[&_.ant-modal-title]:text-white
        dark:[&_.ant-modal-close-x]:text-white
        dark:[&_.ant-modal-footer]:border-gray-700
      "
    >
      <p className="text-gray-700 dark:text-gray-300">Are you sure you want to log out?</p>
    </Modal>
  );
};

export default LogoutModal;
